import IRequest from "../../IRequest"

export interface IPesquisarFazendas {
    reqFazendas: IRequest<IFazendas>,
    dataFazendas: IFazendas[]
  }


export interface IFazendas {
    cooperativa_id: number,
    tipo_publico: string,
    codigo_publico: number,
    nome: string,
    id: string,
    siare: string,
    area: string,
    area_produtiva: string,
    apelido: number,
}

export const defValueFazendas = {
    cooperativa_id: 0,
    tipo_publico: '',
    codigo_publico: 0,
    nome: '',
    id: '',
    siare: '',
    area: '',
    area_produtiva: '',
    apelido: 0,
}